import { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getEstimate, getPaymentEstimate, getHomeServiceEstimate } from 'app/store/modules/homeservice/estimate';

export default function useEstimate() {
	const { init, estimateInfo, paymentEstimateInfo } = useSelector((state) => state.homeservice.estimate, shallowEqual);
	const dispatch = useDispatch();

	const getEstimateInfo = useCallback(
		(carId, buildingCd, extendedWarrantyMonth, auth) => dispatch(getEstimate(carId, buildingCd, extendedWarrantyMonth, auth)),
		[dispatch],
	);

	const getPaymentEstimateInfo = useCallback((applicationUuid) => dispatch(getPaymentEstimate(applicationUuid)), [dispatch]);

	const getHomeServiceEstimateInfo = useCallback(
		(carId, buildingCd, extendedWarrantyMonth, userId) => dispatch(getHomeServiceEstimate(carId, buildingCd, extendedWarrantyMonth, userId)),
		[dispatch],
	);

	return {
		init,
		estimateInfo,
		paymentEstimateInfo,
		getEstimateInfo,
		getPaymentEstimateInfo,
		getHomeServiceEstimateInfo,
	};
}
